import { Button, Modal } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";

import { DomainBanner } from "../../domain-banner";

export interface ILeaveCreateProcessConfirmModalProps {
    isOpen: boolean;
    onClose: (action: "confirm" | "cancel" | "close") => void;
    trademarkName?: string;
    domain?: string;
    isNew?: boolean;
}

export const LeaveCreateProcessConfirmModal = ({
    isOpen,
    onClose,
    trademarkName,
    domain,
    isNew,
}: ILeaveCreateProcessConfirmModalProps) => {
    const translate = useTranslation();

    return (
        <Modal
            customStyles={{
                wrapper: {
                    width: "550px",
                },
            }}
            isOpen={isOpen}
            onRequestClose={() => onClose("close")}
        >
            <Modal.Header>
                <Text fontVariant="h5_2">
                    {isNew
                        ? translate("monitor_and_protect.shared.leave_create_process_confirm_modal.title_create")
                        : translate("monitor_and_protect.shared.leave_create_process_confirm_modal.title_edit")}
                </Text>
            </Modal.Header>
            <Modal.Content gap="24px">
                <DomainBanner
                    domain={domain}
                    name={trademarkName}
                />
                <Text fontVariant="caption">
                    {translate("monitor_and_protect.shared.leave_create_process_confirm_modal.unsaved_changes_message")}
                </Text>
            </Modal.Content>
            <Modal.Footer>
                <Button
                    type="flat"
                    onClick={() => onClose?.("cancel")}
                >
                    {isNew
                        ? translate(
                              "monitor_and_protect.shared.leave_create_process_confirm_modal.stay_in_creation_button",
                          )
                        : translate(
                              "monitor_and_protect.shared.leave_create_process_confirm_modal.stay_in_editing_button",
                          )}
                </Button>
                <Button
                    onClick={() => onClose?.("confirm")}
                    type="warning"
                >
                    {translate(
                        "monitor_and_protect.shared.leave_create_process_confirm_modal.leave_without_saving_button",
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
